module.exports = __webpack_public_path__ + "img/knc.ff71ac6d.svg";